import { render, staticRenderFns } from "./item-management.vue?vue&type=template&id=76808912&scoped=true"
import script from "./item-management.vue?vue&type=script&lang=js"
export * from "./item-management.vue?vue&type=script&lang=js"
import style0 from "./item-management.vue?vue&type=style&index=0&id=76808912&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76808912",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76808912')) {
      api.createRecord('76808912', component.options)
    } else {
      api.reload('76808912', component.options)
    }
    module.hot.accept("./item-management.vue?vue&type=template&id=76808912&scoped=true", function () {
      api.rerender('76808912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/item-management.vue"
export default component.exports